<template>
  <a-modal
    :visible="visible"
    :closable="false"
    :footer="null"
    :destroy-on-close="true"
    :width="676"
    :title="$t('page_device_see_picture')"
    @cancel="handleCancel"
  >
    <ul id="imgGallery" style="height: 700px">
      <template v-for="(img, i) in imgsNative">
        <li style="height: 100px; width:100px; overflow:hidden;opacity: 0;" :key="i">
          <img style="width: 100%;height auto" :src="img.img" />
        </li>
      </template>
    </ul>
  </a-modal>
</template>

<script>
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
export default {
  name: 'Gallery',
  props: {
    imgs: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentIndex: 0,
      imgsNative: []
    }
  },
  computed: {
    length() {
      return this.imgs.length
    }
  },
  watch: {
    index: {
      handler(newVal) {
        this.currentIndex = newVal
        setTimeout(() => {
          if (this.visible && this.imgs && this.imgs.length) {
            const pictureDiv = document.getElementById('imgGallery')
            const viewer = new Viewer(pictureDiv, {
              inline: true,
              url: 'src',
              navbar: true,
              zoomRatio: 0.4,
              button: true,
              title: false,
              keyboard: false,
              initialViewIndex: newVal,
              toolbar: {
                zoomIn: 1,
                zoomOut: 1,
                oneToOne: 1,
                reset: 1,
                prev: 1,
                play: 0,
                next: 1,
                rotateLeft: 1,
                rotateRight: 1,
                flipHorizontal: 1,
                flipVertical: 1
              },
              show: function() {
                // 动态加载图片后，更新实例
                viewer.update()
              }
            })
          }
        }, 50)
      },
      immediate: true
    },
    imgs: {
      handler(newVal) {
        const imgDoms = newVal.map((item) => {
          const img = document.createElement('img')
          img.src = item
          return img
        })
        this.$nextTick(() => {
          this.imgsNative = imgDoms.map((img, i) => {
            const width = img.width
            const height = img.height
            const size = width > height ? width : height
            const max = size > 600 ? 600 : size
            return {
              img: img.src,
              rotate: 0,
              size: max
            }
          })
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    onLeft() {
      this.currentIndex = this.currentIndex - 1 >= 0 ? this.currentIndex - 1 : this.length - 1
    },
    onRight() {
      this.currentIndex = this.currentIndex + 1 <= this.length - 1 ? this.currentIndex + 1 : 0
    },
    onRotateLeft() {
      this.imgsNative[this.currentIndex].rotate -= 90
    },
    onRotateRight() {
      this.imgsNative[this.currentIndex].rotate += 90
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  position: relative;
  background-size: 100% 100%;
  padding-top: 0;
  padding-bottom: 80px;
  .title {
    position: absolute;
    top: 30px;
    left: 40px;
    color: #000;
  }
}
.bar {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  left: 36px;
  right: 36px;
  bottom: 40px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.6);
  .item {
    font-size: 32px;
    color: #fff;
    &:hover {
      color: #ccc;
    }
  }
}
</style>
